import React, { useState } from "react";
import { Canvas, useThree, useFrame } from "@react-three/fiber";
import { PerformanceMonitor } from "@react-three/drei";
import Background from "./Background";
import NoiseField from "./NoiseField";
import { scrollState, perf, getCameraZ, getCameraY } from "./scrollMath";

function CameraRig() {
  const { camera } = useThree();
  useFrame(() => {
    const p = scrollState.progress;
    camera.position.z += (getCameraZ(p) - camera.position.z) * 0.1;
    camera.position.y += (getCameraY(p) - camera.position.y) * 0.1;
    camera.lookAt(0, 0, 0);
  });
  return null;
}

export default function Scene() {
  const [dpr, setDpr] = useState(1.6);
  return (
    <Canvas
      camera={{ position: [0, 0, 5.6], fov: 45 }}
      dpr={dpr}
      gl={{ antialias: true, alpha: false, powerPreference: "high-performance" }}
    >
      <PerformanceMonitor
        flipflops={3}
        onIncline={() => { setDpr(1.8); perf.quality = 1; }}
        onDecline={() => { setDpr(1); perf.quality = 0.5; }}
        onFallback={() => { setDpr(1); perf.quality = 0.45; }}
      />
      <Background />
      <CameraRig />
      <NoiseField />
    </Canvas>
  );
}
